import React, { PureComponent } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import FontAwesome from 'react-fontawesome';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

const resources = [
  {
    title: 'Naples Service Providers',
    icon: 'book',
    description: 'Find mortgage brokers, appraisers and other Naples service providers.',
    to: '/find-naples-agent?memberType=service_provider'
  },
  {
    title: 'Community Information',
    icon: 'list-alt',
    description: 'Find comprehensive information on Naples communities.',
    to: '/find-community'
  },
  {
    title: 'Golf Courses',
    icon: 'golf-ball',
    description: 'Find comprehensive information on Naples golf courses.',
    to: '/find-golf-course'
  },
  {
    title: 'Assisted Living Facilities',
    icon: 'wheelchair',
    description: 'View licensed Collier and Lee County assisted living facilities.',
    to: '/assisted-living'
  },
  {
    title: 'Naples Area Board of REALTORS<sup>®</sup> Blog',
    icon: 'newspaper',
    description:
      'Official source for local real estate news from Naples Area Board of REALTORS<sup>®</sup>.',
    to: '/blog'
  },
  {
    title: 'REALTOR<sup>®</sup> Code of Ethics',
    icon: 'balance-scale',
    description:
      'Learn more about the ethical obligations required of all REALTORS<sup>®</sup>.',
    href: 'https://documents.nabor.com/ethics/2015-Code-of-Ethics.pdf'
  },
  {
    title: 'Why Use a REALTOR<sup>®</sup>?',
    icon: 'tachometer-alt',
    description:
      'Twelve reasons why you should use a REALTOR<sup>®</sup> for your real estate needs.',
    to: '/why-use-realtor'
  },
  {
    title: 'REALTOR<sup>®</sup> Designations',
    icon: 'certificate',
    description: 'Find out what each REALTOR<sup>®</sup> designation means.',
    to: '/designations'
  },
  {
    title: 'Naples Conference Center',
    icon: 'calendar',
    description:
      'Schedule your next business meeting or event at this professional, convenient and affordable facility.',
    href: 'https://www.nabor.com/about-us/naples-conference-center'
  },
  {
    title: 'Mortgage Calculator',
    icon: 'calculator',
    description: 'Use a simple mortgage calculator to calculate your monthly payment.',
    to: '/mortgage-calculator'
  },
  {
    title: 'Naples Florida Collier Demographics',
    icon: 'users',
    description: 'Information such as climate, population, census information and more.',
    to: '/naples-collier-demographics'
  },
  {
    title: 'Naples Points of Interest',
    icon: 'thumbtack',
    description:
      'Find interesting places to visit in Naples, Collier Collier, and Lee County.',
    to: '/find-poi'
  }
];

class Resources extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.Resources}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/resources">
                <BreadcrumbItem active>Resources</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <Row className={BS.gutters1}>
            {resources.map(({ title, icon, description, to, href }, i) => (
              <Col key={i} sm={6} md={4} className={cx(BS.mb2)}>
                <Card className={styles.resource}>
                  <CardBody className={cx(BS.dFlex)}>
                    <FontAwesome
                      name={icon}
                      fixedWidth
                      size="2x"
                      className={cx(styles.icon, BS.mr3)}
                    />
                    <div>
                      <CardTitle>
                        {to && (
                          <Link to={to}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: title
                              }}
                            />
                          </Link>
                        )}
                        {href && (
                          <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            dangerouslySetInnerHTML={{
                              __html: title
                            }}
                          />
                        )}
                        {!to && !href && (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: title
                            }}
                          />
                        )}
                      </CardTitle>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: description
                        }}
                      />
                      {to && <Link to={to}>Learn More</Link>}
                      {href && (
                        <a href={href} target="_blank">
                          Learn More
                        </a>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>
    );
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/containers/Resources/Resources.js